import { memo } from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import MetricItem from '@features/Analytics/Common/MetricItem';
import ConversionBarChart from './ConversionBarChart';
import { useTranslation } from '@hooks';

export const MetricGrid = styled('div')(() => ({
    display: 'grid',
    gridGap: 16,
    gridTemplateAreas: '"bar metric1 metric2"',
    gridAutoColumns: 'calc(100% - 600px) minmax(270px, 300px) minmax(270px, 300px)',
    marginBottom: 16,
    '@media (max-width: 1280px)': {
        gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
        gridTemplateAreas: '"bar bar" "metric1 metric2"',
    },
    '@media (max-width: 600px)': {
        gridTemplateColumns: '100%',
        gridTemplateAreas: '"bar" "metric1" "metric2"',
    },
}));

const ConversionRates = memo(({ data, isLoading, language }) => {
    const { t } = useTranslation();

    return (
        <MetricGrid>
            <Paper
                elevation={1}
                sx={{
                    padding: '24px 24px 6px',
                    gridArea: 'bar',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    borderRadius: '8px',
                }}
            >
                <Typography variant="title1" sx={{ alignSelf: 'center' }}>
                    {t('AnalyticsConversion.reviewsLifecycle')}
                </Typography>
                <ConversionBarChart data={data} language={language} isLoading={isLoading} />
            </Paper>
            <MetricItem
                title={t('AnalyticsConversion.responseRate')}
                data={{ metric: data.responseRate, delta: data.responseRateDelta }}
                styles={{ gridArea: 'metric1' }}
                withPercentage
                withPercentageDelta
            />
            <MetricItem
                title={t('AnalyticsConversion.reviewRate')}
                tooltip={t('AnalyticsConversion.reviewRateTooltip')}
                data={{ metric: data.reviewRate, delta: data.reviewRateDelta }}
                styles={{ gridArea: 'metric2' }}
                withPercentage
                withPercentageDelta
            />
        </MetricGrid>
    );
});

ConversionRates.displayName = 'ConversionRates';

export default ConversionRates;
